import { render, staticRenderFns } from "./EspeciesTabImpacto.vue?vue&type=template&id=22eea7e6&"
import script from "./EspeciesTabImpacto.vue?vue&type=script&lang=js&"
export * from "./EspeciesTabImpacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports